import { Component, Input } from '@angular/core';
import { ContextualActionComponent } from './contextual-action.component';

@Component({
  moduleId: module.id,
  selector: 'import-review-pies-action',
  templateUrl: 'import-review-pies-action.component.html',
  styleUrls: ['contextual-action.component.scss'],
})
export class ImportReviewPiesActionComponent extends ContextualActionComponent {

  onImportClick() {
    const action = {
      type: 'import-items',
      action: 'import-items',
      meta: {
        statusId: 5
      }
    };
    this.actionSelected.emit(action);
  }
}
